/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/ban-types */
import '../_debug_hook';
import { FixedSizeImpl } from '../data_struct/fixed_size_impl';
import { PRESENTATION_DEBUG_REF } from './common';
import type { MutationFn } from '../data_struct/fixed_size_impl';
import type { Disposer, HookFn, Subscribable } from './common';

/**
 * ## cortex:presentation:SynchronousPresentation
 *
 * @public
 */
export class SynchronousPresentation<T extends object> implements Subscribable<T> {
	private readonly data: FixedSizeImpl<T>;
	private readonly hooks: Map<symbol, HookFn<T>> = new Map();

	constructor(initialValue: T) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		//@ts-ignore
		if (globalThis[PRESENTATION_DEBUG_REF]) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			//@ts-ignore
			globalThis[PRESENTATION_DEBUG_REF].add(this);
		}

		if (typeof initialValue !== 'object') {
			throw new Error('a state can only be represented as an object literal');
		}

		this.data = new FixedSizeImpl(initialValue);
	}

	public subscribe(event: HookFn<T>): Disposer {
		const id = Symbol();

		this.hooks.set(id, event);

		return () => {
			this.hooks.delete(id);
		};
	}

	public write(currentState: Partial<T> | MutationFn<T>): void {
		try {
			const newState = currentState instanceof Function ? currentState(this.data) : currentState;

			const changeSet = this.data.insert(newState);
			this.dispatch(changeSet);
		} catch (error) {
			console.error(`could not mutate the state:\n\n${error}`);
		}
	}

	public read(): Readonly<T> {
		return this.data.extract();
	}

	private dispatch(changeSet?: Set<keyof T>): void {
		this.hooks.forEach((hook) => hook(changeSet));
	}
}
